import React from "react";
import { Link, useLocation } from "react-router-dom";

const Task2Header = ({ permission }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        {permission?.pf_add === 1 && (
          <Link to={`/task/task-list?id=${M_id}`} className="btn btn-primary">
            <span>Back</span>
          </Link>
        )}
      </div>
    </>
  );
};

export default Task2Header;
